var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#0A7CC1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 9.25C21.4421 9.25 22.3881 10.2788 22.9161 11.0908C23.1916 11.5147 23.3898 11.9339 23.5186 12.2432C23.5834 12.3986 23.6323 12.5292 23.6651 12.623C23.6815 12.6699 23.6943 12.708 23.7032 12.7354C23.7049 12.7406 23.7066 12.7455 23.7081 12.75H25.1172C25.6216 12.75 26.0469 13.1256 26.1094 13.626L27.8594 27.626C27.934 28.2228 27.4687 28.75 26.8672 28.75H13.1329L13.0215 28.7441C12.4753 28.6839 12.0708 28.1854 12.1407 27.626L13.8907 13.626C13.9493 13.1569 14.3267 12.7971 14.7891 12.7539L14.8829 12.75H16.292C16.2935 12.7455 16.2952 12.7406 16.2969 12.7354C16.3058 12.7081 16.3186 12.6699 16.335 12.623C16.3679 12.5292 16.4167 12.3986 16.4815 12.2432C16.6103 11.9339 16.8085 11.5147 17.084 11.0908C17.612 10.2788 18.558 9.25009 20.0001 9.25ZM13.6993 27.25H26.3008L24.6758 14.25H15.3243L13.6993 27.25ZM20.0001 10.75C19.3425 10.7501 18.7889 11.2214 18.3419 11.9092C18.149 12.2059 18.0012 12.5074 17.8965 12.75H22.1036C21.9989 12.5074 21.8511 12.2059 21.6583 11.9092C21.2111 11.2214 20.6576 10.75 20.0001 10.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.ad2e9d42451ee0aa84dcf6d45461ca0d.svg";
export { ForwardRef as ReactComponent };